export default "/react/logoFirstData-3e682dda.png";